import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useCallback } from 'react';
import { useVoiceRecorderContext } from './context.js';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import '../LocalizationContext-a82461b5.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import '../ui/Modal.js';
import 'react-dom';
import '../index-a9101009.js';
import '../ui/Button.js';
import '../index-6420013c.js';
import 'prop-types';
import '../ui/Icon.js';
import '../ui/IconButton.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../MediaQueryContext-d6110905.js';
import '../consts-fa6ab3c0.js';
import '../withSendbird.js';

// export interface UseVoiceRecorderProps extends VoiceRecorderEventHandler {
//   /**
//    * onRecordingStarted
//    * onRecordingEnded
//    */
// }
/* eslint-disable no-redeclare */
var VoiceRecorderStatus = {
  PREPARING: 'PREPARING',
  READY_TO_RECORD: 'READY_TO_RECORD',
  RECORDING: 'RECORDING',
  COMPLETED: 'COMPLETED'
};
var noop = function noop() {/* noop */};
var useVoiceRecorder = function useVoiceRecorder(_ref) {
  var _ref$onRecordingStart = _ref.onRecordingStarted,
    _onRecordingStarted = _ref$onRecordingStart === void 0 ? noop : _ref$onRecordingStart,
    _ref$onRecordingEnded = _ref.onRecordingEnded,
    _onRecordingEnded = _ref$onRecordingEnded === void 0 ? noop : _ref$onRecordingEnded;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config;
  var voiceRecord = config.voiceRecord;
  var maxRecordingTime = voiceRecord.maxRecordingTime;
  var voiceRecorder = useVoiceRecorderContext();
  var isRecordable = voiceRecorder.isRecordable;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    recordedFile = _useState2[0],
    setRecordedFile = _useState2[1];
  var _useState3 = useState(VoiceRecorderStatus.PREPARING),
    _useState4 = _slicedToArray(_useState3, 2),
    recordingStatus = _useState4[0],
    setRecordingStatus = _useState4[1];
  useEffect(function () {
    if (isRecordable && recordingStatus === VoiceRecorderStatus.PREPARING) {
      setRecordingStatus(VoiceRecorderStatus.READY_TO_RECORD);
    }
  }, [isRecordable]);
  var start = useCallback(function () {
    voiceRecorder === null || voiceRecorder === void 0 ? void 0 : voiceRecorder.start({
      onRecordingStarted: function onRecordingStarted() {
        setRecordingStatus(VoiceRecorderStatus.RECORDING);
        _onRecordingStarted();
        startTimer();
      },
      onRecordingEnded: function onRecordingEnded(audioFile) {
        setRecordingStatus(VoiceRecorderStatus.COMPLETED);
        _onRecordingEnded(audioFile);
        setRecordedFile(audioFile);
        stopTimer();
      }
    });
  }, [_onRecordingStarted, _onRecordingEnded]);
  var stop = useCallback(function () {
    voiceRecorder === null || voiceRecorder === void 0 ? void 0 : voiceRecorder.stop();
    stopTimer();
  }, [voiceRecorder]);
  var cancel = useCallback(function () {
    stop();
    setRecordedFile(null);
  }, [voiceRecorder]);

  // Timer
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    recordingTime = _useState6[0],
    setRecordingTime = _useState6[1];
  var timer = null;
  function startTimer() {
    stopTimer();
    setRecordingTime(0);
    var interval = setInterval(function () {
      setRecordingTime(function (prevTime) {
        var newTime = prevTime + 100;
        if (newTime > maxRecordingTime) {
          stopTimer();
        }
        return newTime;
      });
    }, 100);
    timer = interval;
  }
  function stopTimer() {
    clearInterval(timer);
    timer = null;
  }
  useEffect(function () {
    if (recordingTime > maxRecordingTime) {
      stop();
    }
  }, [recordingTime, maxRecordingTime, stop]);
  return {
    start: start,
    stop: stop,
    cancel: cancel,
    recordingStatus: recordingStatus,
    recordingTime: recordingTime,
    recordedFile: recordedFile,
    recordingLimit: maxRecordingTime
  };
};
export { VoiceRecorderStatus, useVoiceRecorder };